import { render, staticRenderFns } from "./ReferralDetails.vue?vue&type=template&id=5d11ccde&scoped=true"
import script from "./ReferralDetails.vue?vue&type=script&lang=js"
export * from "./ReferralDetails.vue?vue&type=script&lang=js"
import style0 from "./ReferralDetails.vue?vue&type=style&index=0&id=5d11ccde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d11ccde",
  null
  
)

export default component.exports